import { useCallback, useState } from "react";
import { useEffect } from "react";
import { useMemo } from "react";
import { useRef } from "react";
import YouTube from "react-youtube";
import { GetThumbnail, getYtVideoId } from "../Popup/funcs";
import { YoutubeStep } from "./YoutubeStep";

import "./YoutubeWithSteps.scss";

export const YoutubeWithSteps = ({
  steps,
  youtubeUrl,
  dictionary,
  showVideo,
  showStepsMobile,
}) => {
  const [videoId, setVideoId] = useState(getYtVideoId(youtubeUrl));
  const player = useRef(null);
  const timer = useRef(null);
  const stepContainer = useRef(null);

  const [currentStep, setCurrentStep] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);
  const [thumbnail, setThumbnail] = useState(null);
  const stepsRef = useRef([]);

  const onPlayHandler = useCallback(() => {
    setIsPlaying(true);
  }, []);

  const onPauseHandler = useCallback(() => {
    setIsPlaying(false);
  }, []);

  const startListening = useCallback(() => {
    timer.current = setTimeout(() => {
      trigger();

      if (isPlaying) {
        startListening();
      }
    }, 1000);
  }, [isPlaying]);

  const trigger = useCallback(() => {
    var currentVideoTime = new Date(
      player.current.playerInfo.currentTime * 1000
    );

    checkSteps(currentVideoTime);
  }, [player, currentStep]);

  const stopListening = useCallback(() => {
    clearTimeout(timer.current);
  }, [timer]);

  const checkSteps = useCallback(
    (currentTime) => {
      if (steps && steps.length > 0) {
        var found = false;
        var index = 0;

        do {
          var step = steps[index];

          var stepDate = new Date(
            (step.timestamp.minutes * 60 + step.timestamp.seconds) * 1000
          );

          if (steps.length - 1 !== index) {
            if (stepDate > currentTime) {
              if (currentStep !== index - 1) {
                setCurrentStep(index - 1 >= 0 ? index - 1 : 0);
              }

              found = true;
            }
          } else {
            if (stepDate > currentTime) {
              if (currentStep !== index - 1) {
                setCurrentStep(index - 1 >= 0 ? index - 1 : 0);
              }
            } else if (stepDate <= currentTime) {
              {
                if (currentStep !== index) {
                  setCurrentStep(index);
                }
              }
            }

            found = true;
          }

          index++;
        } while (!found);
      }
    },
    [steps, currentStep]
  );

  const nextStep = () => {
    scrollToCurrent();
    if (currentStep + 1 < steps.length) {
      setCurrentStep(currentStep + 1);
      seekToStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
      seekToStep(currentStep - 1);
    }
  };

  const scrollToCurrent = () => {
    if (steps && stepsRef.current) {
      stepsRef.current[currentStep].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
    }
  };

  const seekToStep = useCallback(
    (step) => {
      var seconds =
        steps[step].timestamp.seconds + steps[step].timestamp.minutes * 60;
      player.current.seekTo(seconds);
    },
    [player]
  );

  useEffect(() => {
    if (isPlaying) {
      startListening();
    } else {
      stopListening();
    }
  }, [isPlaying]);

  useEffect(() => {
    setVideoId(getYtVideoId(youtubeUrl));
    (async () => {
      setThumbnail(await GetThumbnail(youtubeUrl));
    })();
  }, [youtubeUrl]);

  useEffect(() => {
    scrollToCurrent();
  }, [currentStep]);

  const stepsComponents = useMemo(() => {
    if (steps && steps.length > 0) {
      return steps.map((step, index) => {
        const component = (
          <YoutubeStep
            key={index}
            dictionary={dictionary}
            step={step}
            ref={(element) => (stepsRef.current[index] = element)}
            isActive={currentStep == index}
          />
        );
        return component;
      });
    }
  }, [currentStep, steps]);

  return (
    <div className="c-youtube">
      <div className="c-youtube__content">
        {youtubeUrl !== "" && youtubeUrl !== null && (
          <div className="c-youtube__video">
            {showVideo && videoId ? (
              <YouTube
                videoId={videoId}
                id={"c-youtube__video__youtube"}
                onReady={(evt) => (player.current = evt.target)}
                onStateChange={(evt) => trigger()}
                onPlay={() => onPlayHandler()}
                onPause={() => onPauseHandler()}
                opts={{ host: "https://www.youtube-nocookie.com" }}
              />
            ) : (
              <img className="c-youtube__video__thumb" src={thumbnail} />
            )}
          </div>
        )}

        {steps !== null && steps !== undefined && (
          <div
            className={`c-youtube__steps ${
              !showStepsMobile ? "hidden-mobile" : ""
            }`}
          >
            <div className="c-youtube__steps__header">
              <h4>{dictionary.stappen}</h4>
              <div className="c-youtube__steps__header-steps-buttons">
                <button
                  disabled={!showVideo}
                  className="c-senioren__button c-senioren__button--secondary c-senioren__button--icon-only"
                  onClick={() => prevStep()}
                >
                  <i class="fas fa-chevron-up"></i>
                </button>
                {`  ${currentStep + 1}/${steps.length}  `}
                <button
                  disabled={!showVideo}
                  className="c-senioren__button c-senioren__button--secondary c-senioren__button--icon-only"
                  onClick={() => nextStep()}
                >
                  <i class="fas fa-chevron-down"></i>
                </button>
              </div>
            </div>
            <div className={`c-youtube__steps__content`} ref={stepContainer}>
              {stepsComponents}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
